import { Box } from "arkh";

export const PILL_INDICATOR_SIZE = {
  width: 110,
  height: 15,
  padding: 3,
};

export function PillIndicator(props: { percentage: number; width?: number }) {
  return (
    <Box
      cornerRadius="large"
      color="background"
      style={{
        height: PILL_INDICATOR_SIZE.height,
        width: props.width ?? PILL_INDICATOR_SIZE.width,
        alignItems: "center",
        flexDirection: "row",
        paddingHorizontal: PILL_INDICATOR_SIZE.padding,
      }}
    >
      <Box
        style={{
          height: PILL_INDICATOR_SIZE.height - PILL_INDICATOR_SIZE.padding * 2,
          width: `${props.percentage}%`,
        }}
        color="positive"
        cornerRadius="large"
      />
    </Box>
  );
}
